// extracted by mini-css-extract-plugin
module.exports = {"studyCard":"studyCard__3Q2zk","title":"title__1KDP4","description":"description__34IzP","date":"date__19Mub","participants":"participants__2qdXB"};